import { Component, forwardRef, Input, OnInit } from '@angular/core';
import { AbstractControl, ControlValueAccessor, NG_VALIDATORS, NG_VALUE_ACCESSOR, ValidationErrors, Validator } from '@angular/forms';
import { DropdownItem } from 'src/app/shared/types/dropdown-item.iterface';

@Component({
  selector: 'app-autocomplete',
  templateUrl: './autocomplete.component.html',
  styleUrls: ['./autocomplete.component.scss'],
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => AutocompleteComponent),
    multi: true
  }]
})
export class AutocompleteComponent implements OnInit, ControlValueAccessor {
  @Input() list: DropdownItem[];
  @Input() disabled: boolean;
  @Input() size: number = 15;
  filteredList: DropdownItem[] = [];
  ngModelValue: any;

  constructor() { }

  ngOnInit(): void {
  }

  onChange: (_: any) => void = (_: any) => {};

  onTouched: () => void = () => {};

  updateChanges() {
    this.onChange(this.ngModelValue?.key);
  }

  writeValue(value: string): void {
    this.ngModelValue = this.list?.find(item => item.key === value);
    this.updateChanges();
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  search(event) {
    this.filteredList = this.list.filter(
      item => item.value.toString().toLowerCase().includes(event.query.toLowerCase())
    );
    this.onTouched();
  }
}
